import { render, staticRenderFns } from "./ciaHeader.vue?vue&type=template&id=fbb20982&"
import script from "./ciaHeader.vue?vue&type=script&lang=js&"
export * from "./ciaHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ciaHeader.vue"
export default component.exports